const SITE_URL = 'https://coursepress.lnu.se'
const PATH_PREFIX = '/kurser/mjukvaruutvecklingsprojekt-vt23'

const config = {
  gatsby: {
    pathPrefix: PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null
  },
  header: {
    logoLink: '/',
    title: 'logo-wordmark-sv.png',
    courseName: 'Mjukvaruutvecklingsprojekt (1DV613)',
    links: [
      { text: 'GitLab', link: 'https://gitlab.lnu.se/1dv613' },
      { text: 'Zoom', link: `${SITE_URL}${PATH_PREFIX}/zoom` },
      { text: 'MyMoodle', link: 'https://mymoodle.lnu.se/course/view.php?id=58936'},
      { text: 'YouTube', link: 'https://www.youtube.com/cslnu' },
      { text: 'Schema', link: 'https://cloud.timeedit.net/lnu/web/schema2/riqv7Q29Y8XZ9QQyY8772Yn06hZ8w574ZZd6X45Q9Yo9y5cQbQm5cowqZpQcZc6Qn.html'}
    ]
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true
  },
  siteMetadata: {
    title: 'Linnéuniversitetet',
    courseCode: '1DV613',
    language: "sv",
    description: 'Documentation built with mdx. Powering learn.hasura.io ',
    ogImage: null
  }
}

module.exports = config
